import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HelpConfig } from '@config/help-config';
import { MatriculaGestaoModel, MatriculaUpdateRequestModel } from '@models/gestao/matricula-gestao.model';
import { CargaRenachModel } from '@core/models/gestao/carga-renach.model';
import { BaseResourceService } from '@core/services/outros/base-resource.service';

@Injectable({
  providedIn: 'root',
})
export class MatriculaService extends BaseResourceService<MatriculaGestaoModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.MANAGEMENT_API}matriculas`, injector);
  }

  cancel(id: number, comments: string): Observable<MatriculaGestaoModel> {
    return this._httpClient.delete<MatriculaGestaoModel>(
      `${this._url}/${id}?motivo=${comments}`
    );
  }

  getCargaRenach(params: string): Observable<CargaRenachModel> {
    const END_POINT = '/cargarenach'
    return this._httpClient.post<CargaRenachModel>(`${this._url}${END_POINT}?${params}`, null);
  }
/*
  getByCpf(params: string): Observable<CargaRenachModel> {
    const END_POINT = '/matriculabyCpf'
    return this._httpClient.post<CargaRenachModel>(`${this._url}${END_POINT}?${params}`, null);
  } */

  updateMatricula(resource: MatriculaUpdateRequestModel): Observable<MatriculaUpdateRequestModel> {
    return this._httpClient.put<MatriculaUpdateRequestModel>(this._url, resource);
  }

  cargaPreMatricula(matriculaId): Observable<MatriculaGestaoModel> {
    const END_POINT = '/cargaprematricula'
    return this._httpClient.post<MatriculaGestaoModel>(`${this._url}${END_POINT}?matriculaId=${matriculaId}`, null);
  }
  
  getMatriculaIdExternoCandidate(cpf: string): Observable<any[]> {
    return this._httpClient.get<any[]>(`${this._url}?Cpf=${cpf}`);
  }

  registoLadv(data: any): Observable<any> {
    return this._httpClient.post<any>(`${this._url}/ladv/registrar`, data);
  }

  consultaLadv(params: any): Observable<any> {
    return this._httpClient.get<any>(`${this._url}/ladv/buscar`, { params });
  }

  consultaPortalDeMatriculas(params: any): Observable<any> {
    return this._httpClient.get<any>(`${this._url}/portalDeMatricula`, { params });
  }

  importarMatriculaPortal(data: any): Observable<any> {
    return this._httpClient.post<any>(
      `${this._url}/portalDeMatriculas?renach=${data.renach}&cfcCnpj=${data.cfcCnpj}`,
      null
    );
  }

  cargaPortalDeMatricula(matriculaId: any): Observable<any> {
    return this._httpClient.post<any>(
      `${this._url}/cargaportaldematricula?matriculaId=${matriculaId}`,
      null
    );
  }
}